import { images } from ".";

const profile = {
    image: images.profile,
    name: 'Henry Charlwood',
    gmail: 'abc@gmail.com',
    contactNo: '0123456789',
    address: [ 
        { 
            id: 1,
            title: 'shipping address',
            name: 'Henry Charlwood',
            country: 'Ireland',
            city: 'Dublin',
            province: 'Leinster',
            ZIP: 'D02 Y006',
            address: '3rd Floor, Harcourt Centre, Harcourt Road',
        },
        {
            id: 2,
            title: 'billing address',
            name: 'Henry Charlwood',
            country: 'Ireland',
            city: 'Dublin',
            province: 'Leinster',
            ZIP: 'D02 Y006',
            address: '3rd Floor, Harcourt Centre, Harcourt Road',
        },
    ],
};

export default profile;